const mutations = {
    STATS_LOADING: (state) => {
        // state.statsStatus = 'loading';
        Vue.set(state, 'statsStatus', 'loading');
    },
    SEASONS_SUCCESS: (state, data) => {
        state.statsStatus = 'success';
        Vue.set(state, 'seasons', data);
    },
    DIVISIONS_SUCCESS: (state, data) => {
        state.statsStatus = 'success';
        Vue.set(state, 'divisions', data);
        Vue.set(state, 'stats', []);
        Vue.set(state, 'teams', []);
    },
    TEAMS_SUCCESS: (state, data) => {
        state.statsStatus = 'success';
        Vue.set(state, 'teams', data);
    },
    GAMES_SUCCESS: (state, data) => {
        state.statsStatus = 'success';
        Vue.set(state, 'games', data);
    },
    STATS_SUCCESS: (state, data) => {
        state.statsStatus = 'success';
        Vue.set(state, 'stats', data);
    },
    STATS_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.statsStatus = 'error';
        state.statsErrors.record(errors);
    },
    CLEAR_STATS_ERRORS: (state) => {
        state.statsStatus = '';
        state.statsErrors.clear();
    },
    CLEAR_STATS_TEAMS: (state) => {
        state.teams = [];
    },
    CLEAR_STATS_GAMES: (state) => {
        state.games = [];
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
